import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AnatomicMapDirective } from './map/anatomicMapDirective/anatomic-map.directive';
import { MapComponent } from './map/map.component';
import { CommonModule } from '@angular/common';
import { MapContainerComponent } from './map-container/map-container.component';
import { AnatomicMapTooltipComponent } from './components/anatomic-map-tooltip/anatomic-map-tooltip.component';
import { AnatomicMapTooltipDirective } from './components/anatomic-map-tooltip/anatomic-map-tooltip.directive';
import { LegendButtonComponent } from './components/legend-button/legend-button.component';
import { MultiStageMapContainerComponent } from './multistage-map-container/multistage-map-container.component';
import { MapLoadingComponent } from './components/map-loading/map-loading.component';

@NgModule({
    declarations: [
        // All components are now standalone, so no declarations needed
        // Keeping the module for backward compatibility and service provision
    ],
    imports: [
        CommonModule,
        TranslateModule,
        // Import standalone components for re-export
        MapContainerComponent,
        MultiStageMapContainerComponent,
        MapComponent,
        AnatomicMapDirective,
        AnatomicMapTooltipComponent,
        AnatomicMapTooltipDirective,
        LegendButtonComponent,
        MapLoadingComponent,
        // LegendComponent is imported at module level to avoid circular dependency
        // during testing cleanup in MapContainerComponent
    ],
    exports: [
        // Re-export standalone components for backward compatibility
        MapContainerComponent,
        MultiStageMapContainerComponent,
        MapComponent,
        MapLoadingComponent,
        AnatomicMapDirective,
        AnatomicMapTooltipComponent,
        AnatomicMapTooltipDirective,
        LegendButtonComponent,
        // LegendComponent is no longer exported to avoid circular dependency issues
    ],
})
export class SeUiAnatomicMapModule {}
